// // npm install sematic-ui-react semantic-ui-css react-router-dom
// import { Menu, Search, Icon, Segment } from "semantic-ui-react";
// // react-router-dom version 6 need to use useNavigate (not useHistory)
// import { Link, useNavigate } from "react-router-dom";  // need to use (BrwoserRouter) before using Link 

// import { useMediaQuery } from 'react-responsive';

// import React, { useState } from "react";

// import firebase from "./utils/firebase";

// import algolia from "./utils/algolia";

// function Header({ user }) {

//     const navigate = useNavigate();
//     const [inputValue, setInputValue] = React.useState("");
//     const [results, setResults] = React.useState([]);

//     // function to show search result on the Header
//     function onSearchChange(e, { value }) {

//         setInputValue(value);

//         algolia.search(value).then((result) => {

//             // print out result on web console
//             // console.log(result.hits);

//             const searchResults = result.hits.map(hit => {
//                 return {
//                     title: hit.title,
//                     description: hit.content,
//                     id: hit.objectID,
//                 };
//             });
//             setResults(searchResults);
//         });
//     }

//     function onResultSelect(e, { result }) {
//         // history.push not working
//         navigate(`/posts/${result.id}`)
//     }


    
//     // use monitoring function from App.js
//     // // monitoring the state of signed or not
//     // // initializinig state, not sure signed or not => null
//     // const [user, setUser] = React.useState(null);
//     // // after signOut, the currentUser will become null
//     // React.useEffect(() => {
//     //     firebase.auth().onAuthStateChanged((currentUser) => {
//     //         setUser(currentUser);
//     //     });
//     // }, []);


//     const menuStyle = {
//         backgroundColor: 'white',
//         color: 'black', // Set text color to black
//         borderRadius: '0'  // Optional: removes rounded corners if you prefer
//     };

//     // navbar
//     // to="/" is homepage
//     // click Register/Login leads to /signin
//     // click Social Platform leads to homepage
//     return (
//         <Segment attached size='mini' style={menuStyle} >
//             <Menu secondary style={menuStyle} >
//             <Menu.Item as={Link} to="/posts">  
//                 {/* Social Platform */}
//                 <Icon name="home" />
//             </Menu.Item> 
//             <Menu.Item>
//                 {/* use search function */}
//                 <Search
//                     value={inputValue}
//                     onSearchChange={onSearchChange}
//                     results={results}
//                     noResultsMessage="No posts found."
//                     onResultSelect={onResultSelect}
//                     style={{ width: '200px' }} // Adjust the width as needed
//                 />
//             </Menu.Item>
//             <Menu.Menu position="right">
//                 {user ? (
//                     <>
//                         <Menu.Item as={Link} to="/new-post">
//                             Publish
//                         </Menu.Item>
//                         <Menu.Item as={Link} to="/my/posts">
//                             Account
//                         </Menu.Item>
//                         {/* after signOut, the currentUser will become null */}
//                         <Menu.Item onClick={() => firebase.auth().signOut()}>
//                             Log out
//                         </Menu.Item>
//                         </>
//                     ) : (
//                         <Menu.Item as={Link} to="/signin">
//                             {/* Register/Login */}
//                             Start
//                         </Menu.Item>
//                     )}
//                 </Menu.Menu>
//             </Menu>
//         </Segment>
//     )
//     ;
// }

// export default Header;


import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Menu, Search, Icon, Segment, Sidebar} from 'semantic-ui-react';
import { Link, useNavigate } from 'react-router-dom';

import firebase from "./utils/firebase";
import algolia from "./utils/algolia";

// Overlay component for NavbarMb
function Overlay({hide}) {
    return (
      <div 
    //   style={{
    //     backgroundColor: "rgba(0, 0, 0, 0.795)",
    //     position: "fixed",
    //     height: "110vh",
    //     width: "100%",
    //   }} 
        onClick={hide} // Close sidebar when overlay is clicked
        style={{
        backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        zIndex: 10, // Below the sidebar but above other content
        }} 
      />
    );
  }
  

// Icons for NavbarMb
function HamIcon() {
  return (<i className="big bars icon" />);
}

// function CloseIcon() {
//   return (<i className="big close red icon" />);
// }

// Define a common style for white background and black text
const commonStyle = {
    backgroundColor: 'white', // White background
    color: 'black', // Black text
  };

// NavbarMb Component
function NavbarMb({ renderLinks }) {

    const [visible, setVisible] = useState(false);
    const [icon, setIcon] = useState(<HamIcon />);
  
    // const hideSidebar = () => {
    //     setVisible(false);
    //     setIcon(<HamIcon />);
    // };
  
    // const showSidebar = () => {
    //     setVisible(!visible);
    //     setIcon(visible ? <HamIcon /> : <CloseIcon />);
    // };
  
    const toggleSidebar = () => {
        setVisible(!visible);
        // setIcon(visible ? <HamIcon /> : <CloseIcon />);
    };
  
    // // Updated style for the Sidebar
    // const sidebarStyle = {
    //     backgroundColor: 'white', // White background for the sidebar
    //     color: 'black', // Black text for the sidebar
    //     width: 'wide', // Set the width as required
    //     display: 'flex', 
    //     alignItems: 'center'
    // };

    // Style for the sidebar content to center items
    const sidebarContentStyle = {
      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'center',
      alignItems: 'flex-start',
      height: '100%', // Full height
    };

    return (
      <>
        {visible && <Overlay hide={() => setVisible(false)} />}
        <Menu size="tiny" borderless attached style={commonStyle}>
            <Menu.Item as={Link} to="/posts" style={commonStyle}>
              <Icon name="home"/>
            </Menu.Item>
            <Menu.Menu position='right'>
              <Menu.Item onClick={toggleSidebar} style={commonStyle}>
                {icon}
              </Menu.Item>
            </Menu.Menu>
        </Menu>
        <Sidebar
          as={Menu}
          animation='overlay'
          vertical
          visible={visible}
          direction='right'
          width='normal'
          style={{...commonStyle, zIndex: 20}}
        >
        <div style={sidebarContentStyle}>
          {renderLinks()}
        </div>
        </Sidebar>
      </>
    );
  }

// NavbarLg Component
function NavbarLg({ renderLinks }) {
  return (
    <Segment attached size='mini' style={commonStyle}>
      <Menu secondary style={commonStyle}>
        {renderLinks()}
      </Menu>
    </Segment>
  );
}

// Header Component
function Header({ user }) {
  
    const navigate = useNavigate();
    const [inputValue, setInputValue] = useState("");
    const [results, setResults] = useState([]);
    const isMobile = useMediaQuery({ query: "(max-width: 685px)" });

    // Adjust the width of the search field based on screen size
    const searchStyle = {
        width: isMobile ? '150px' : '200px', // Smaller width for mobile screens
    };

    function onSearchChange(e, { value }) {

        setInputValue(value);

        algolia.search(value).then((result) => {

            // print out result on web console
            // console.log(result.hits);

            const searchResults = result.hits.map(hit => {
                return {
                    title: hit.title,
                    description: hit.content,
                    id: hit.objectID,
                };
            });
            setResults(searchResults);
        });
    }

    function onResultSelect(e, { result }) {
        navigate(`/posts/${result.id}`);
    }

    const renderLinks = () => {
        return (
          <>
            <Menu.Item as={Link} to="/posts">  
                <Icon name="home" />
            </Menu.Item> 
            <Menu.Item>
                {/* use search function */}
                <Search
                    value={inputValue}
                    onSearchChange={onSearchChange}
                    results={results}
                    noResultsMessage="No posts found."
                    onResultSelect={onResultSelect}
                    style={searchStyle} // Apply dynamic styling
                />
            </Menu.Item>
            <Menu.Menu position="right">
                {user ? (
                    <>
                        <Menu.Item as={Link} to="/new-post">
                            Publish
                        </Menu.Item>
                        <Menu.Item as={Link} to="/my/posts">
                            Account
                        </Menu.Item>
                        {/* after signOut, the currentUser will become null */}
                        <Menu.Item onClick={() => firebase.auth().signOut()}>
                            Log out
                        </Menu.Item>
                        </>
                    ) : (
                        <Menu.Item as={Link} to="/signin">
                            {/* Register/Login */}
                            Login/Register
                        </Menu.Item>
                    )}
            </Menu.Menu>
          </>
        );
      };

    const menuStyle = {
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '0'
    };

    return (
        <Segment attached size='mini' style={commonStyle} >
            {isMobile ? (
                <NavbarMb renderLinks={renderLinks} />
            ) : (
                <NavbarLg renderLinks={renderLinks} />
            )}
        </Segment>
    );
}

export default Header;